import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";

import { CheckboxGroupWithAccordionField } from "@/components/ui/form/fields/check-box-field/check-box-group-with-accordion";

import { useRoomAmenities } from "./hooks";

export const QuestionRoomAmenities = () => {
	const { rawAmenities, roomAmenities, roomFacilities, bathRoomAmenities, onSetAmenities, isEdited, hasError } =
		useRoomAmenities();

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={"部屋のアメニティ・設備"}
			guide="ホテルポリシーで設定した以外のアメニティや設備が存在する場合は、こちらで追加設定が可能です。"
			isEdited={isEdited}
			hasError={hasError}
			inputChildren={
				<>
					<CheckboxGroupWithAccordionField
						accordionLabel="部屋のアメニティ"
						checkBoxGroupProps={{
							value: rawAmenities,
							options: roomAmenities,
							handleCheckedChange: onSetAmenities,
							gridCols: 2,
						}}
					/>
					<CheckboxGroupWithAccordionField
						accordionLabel="部屋の設備"
						checkBoxGroupProps={{
							value: rawAmenities,
							options: roomFacilities,
							handleCheckedChange: onSetAmenities,
							gridCols: 2,
						}}
					/>
					<CheckboxGroupWithAccordionField
						accordionLabel="バスルーム"
						checkBoxGroupProps={{
							value: rawAmenities,
							options: bathRoomAmenities,
							handleCheckedChange: onSetAmenities,
							gridCols: 2,
						}}
					/>
				</>
			}
		/>
	);
};

QuestionRoomAmenities.displayName = "QuestionRoomAmenities";
